export default {
  baseUrl: '/',
  strictBaseUrl: false,
  images: {
    uploadUrl: '/api/uploads',
  },
};



// WEBPACK FOOTER //
// ./src/Api/defaultOptions.js